import { Row } from '@/components'
import { ThemeColor } from '@/enums'
import { GoogleRatingIcon } from '@/icons'
import { GoogleIcon } from '@/icons/GoogleIcon'
import { TrustPilotExtended } from '@/icons/TrustPilotExtended'
import { range } from 'ramda'
import styled from 'styled-components'

const Container = styled(Row)`
  align-items: center;
  gap: 6px;
`

const StyledGoogleIcon = styled(GoogleIcon)`
  width: 26px;
  height: 26px;
`

const Google = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const GoogleRating = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const CheckoutTrustPartners = () => {
  return (
    <Container>
      <TrustPilotExtended width="220px" height="22px" />
      <Google>
        <StyledGoogleIcon />
        <GoogleRating>
          {range(1, 6).map((item) => (
            <GoogleRatingIcon
              key={item}
              color={ThemeColor.warning2}
              size="info"
            />
          ))}
        </GoogleRating>
      </Google>
    </Container>
  )
}
